import React, { FC, HTMLAttributes, memo } from "react";
import styled from "styled-components";
import { APPEAL_CONTENT_WIDTH } from "./calculation/theme";
import AnswererRow from "./dialogue/AnswererRow";
import UserRow from "./dialogue/UserRow";

export type Props = HTMLAttributes<HTMLDivElement>;
const DialogueArea: FC<Props> = ({ ...props }) => {
  return (
    <Root {...props}>
      <Container>
        <UserRow image="/dialogue/mascot-icon-1-pc.png">寄附するとなにかいいことあるの？</UserRow>
        <AnswererRow image="/dialogue/af-icon-pc.png">
          <div>
            <Text>自己負担2000円でアニメに関連した</Text>
            <Text>返礼品がもらえるよ。</Text>
          </div>
        </AnswererRow>
        <UserRow image="/dialogue/mascot-icon-2-pc.png">お得に好きなアニメの返礼品がもらえるのね！</UserRow>
        <UserRow image="/dialogue/mascot-icon-1-pc.png">ちなみに寄附したお金は何に使われるの？</UserRow>
        <AnswererRow image="/dialogue/af-icon-pc.png">
          その自治体の地域活動に使われるよ。
          <br />
          <Text>聖地の整備やイベント開催などのアニメと</Text>
          <Text>タイアップした活動に使われることもあるよ。</Text>
        </AnswererRow>
        <UserRow image="/dialogue/mascot-icon-3-pc.png">
          それならやってみたいかも！
          <br />
          早速いくら寄附できるか調べてみるね♪
        </UserRow>
      </Container>
    </Root>
  );
};
export default memo(DialogueArea);

const Root = styled.div`
  @media screen and (max-width: 960px) {
    padding: 15vw 5vw;
  }
  @media screen and (min-width: 601px) and (max-width: 960px) {
    padding: 90px 30px;
  }
  @media screen and (min-width: 961px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
const Container = styled.div`
  @media screen and (min-width: 961px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  ${APPEAL_CONTENT_WIDTH};
`;
const Text = styled.span`
  display: inline-block;
`;
